import React from 'react';
interface SectionHeadingProps {
  overline: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeading({
  overline,
  title,
  description,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  return <div className={`flex flex-col ${align === 'center' ? 'items-center text-center' : 'items-start text-left'} ${className}`} data-id="element-116">
      <span className="text-gold text-sm font-medium uppercase tracking-[0.3em] mb-4 block" data-id="element-117">
        {overline}
      </span>
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight text-balance" data-id="element-118">
        {title}
      </h2>
      {description && <p className="text-muted text-lg max-w-2xl leading-relaxed" data-id="element-119">
          {description}
        </p>}
    </div>;
}